var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[_c('AppBar'),_c('v-main',[_c('v-container',[_c('MainScreenMonitorRamais')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }